import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';
import qs from 'qs';

const queryFn = ({ contractId }: QueryParams) => {
    const querystring = qs.stringify({ contractId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getStoredFilterBulkAssignToUser${querystring}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};

export const useQueryGetStoredFilterBulkAssignToUser = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys]>({
        queryKey: ['getStoredFilterBulkAssignToUser'],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.contractId),
    });
};

interface QueryParams {
    contractId?: number;
}

export interface QueryResponse {
    info: IToolTip;
    userAssignRule: {
        lastRunActivities: number;
        id: number;
        ruleRank: number;
        appliedFilter: string;
        LastRunActivities: number;
        updatedBy: string;
        updatedByName: string;
        lastUpdate: number;
        assignee: string;
        assigneeName: string;
    }[];
}
